import { render, staticRenderFns } from "./TransportadoraTpCalcForm.vue?vue&type=template&id=7c28089a"
import script from "./TransportadoraTpCalcForm.vue?vue&type=script&lang=js"
export * from "./TransportadoraTpCalcForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports